import React, { useMemo } from "react";
import { Row, Col } from "antd";
import { Form, InputNumber } from "formik-antd";
import { useTranslation } from "react-i18next";
import { IconToolTip } from "/app/src/components/icons/IconBuilder";

/**
 * Form for creating and updating the max records setting
 * @param integration Integration
 */
export default function MaxRecords() {
  const { t } = useTranslation();

  const labelContent = useMemo(
    () => (
      <>
        {t("translation:max_records")}
        <IconToolTip
          content={t("translation:max_records_tip")}
          className="ml-1"
        />
      </>
    ),
    [t],
  );

  return (
    <Row justify="start" gutter={16}>
      <Col span={24}>
        <Form.Item name="maxRecords" label={labelContent} hasFeedback={false}>
          <InputNumber
            name="maxRecords"
            min={1}
            max={100}
            size="large"
            style={{ width: "100%" }}
            placeholder={"10"}
          />
        </Form.Item>
      </Col>
    </Row>
  );
}
